import useCompanyContext from 'common/hooks/useCompanyContext';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';
import { refetchGetClients } from 'features/Work/pages/Clients/pages/List/hooks/queries/useGetClients';

import {
  DeleteClientDocument,
  DeleteClientMutation,
  DeleteClientMutationVariables,
} from './graphql/deleteClient.gql';

export const useDeleteClientMutation = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error('companyProfileId is undefined in useDeleteClientMutation');
  }

  return useErrorHandledMutation<
    DeleteClientMutation,
    DeleteClientMutationVariables
  >(DeleteClientDocument, {
    refetchQueries: [refetchGetClients(companyProfileId)],
  });
};
